import { Environment } from '@cko/dashboard-shared/types/environment';

type DashboardAppConfig = {
  environment: Environment;
  name: string;
  version: string;
};

export const APP_CONFIG: DashboardAppConfig = {
  environment: window.__app_config.WEBUI_ENV_NAME,
  name: window.__app_config.WEBUI_APP_NAME,
  version: window.__app_config.WEBUI_APP_VERSION,
};
